export const locale = {
    lang: 'en',
    data: {
        'NAVBAR': {
            'COTISATION': 'Contribution',
            'LOGOUT': 'Logout',
            'UPTODATE': 'Up to date',
            'NOTUPTODATE': 'Not up to date',
            'MAIL': 'New email',
            "OPERATIONCANCELED": "Operation canceled",
            "CLOSE": "Close",
            "NEWCOTISATION": "New contribution to pay, Amount",
            "NONOTIFICATIONS": "No notifications",
            "AMOUNT":"Amount",
            "SWITCH_TO_ADMIN": "Switch to admin mode",
            "SWITCH_TO_USER": "Switch to user mode",
        },
        'CHANGEPASSWORD': {
            'TITLE': 'Change Password',
            'CURRENTPASSWORD': 'Current Password',
            'CURRENTPASSWORDPLACEHOLDER': 'Enter your current password',
            'CURRENTPASSWORDREQUIRED': 'Current password is required',
            'NEWPASSWORD': 'New Password',
            'NEWPASSWORDPLACEHOLDER': 'Enter your new password',
            'NEWPASSWORDREQUIRED': 'New password is required',
            'NEWPASSWORDMINLENGTH': 'Password must be at least 6 characters long',
            'CONFIRMPASSWORD': 'Confirm Password',
            'CONFIRMPASSWORDPLACEHOLDER': 'Confirm your new password',
            'CONFIRMPASSWORDREQUIRED': 'Password confirmation is required',
            'PASSWORDMISMATCH': 'Passwords do not match',
            'SUBMIT': 'Change Password',
            'RESET': 'Reset',
            'SUCCESS': 'Password changed successfully',
            'ERROR': 'Error changing password',
            'INVALIDCURRENTPASSWORD': 'Current password is incorrect'
        }
    }
};
